import React from "react";
import IconWrapper from "./IconWrapper";
import { FaBuilding } from "react-icons/fa6";

const IconHeadquarters = () => {

    return (
        <IconWrapper>
            <FaBuilding size="40px" />            
        </IconWrapper>
    );
}

export default IconHeadquarters;
